<div class="top-sidebar d-flex align-items-center">
    <div class="d-flex left-side">
        <div class="duration d-inline-flex">
            <div class="img d-inline-flex float-left">
                <img class="clock-duration" src="../../../../../assets/images/clock-duration.png"
                    alt="clock-duration" />
            </div>
            <div class="boxduration-name">
                <div class="duration-text">{{ 'Duration' | translate }}</div>
                <div class="duration-time font-bold d-flex align-items-center">
                    <span class="d-flex float-left" style="width: 65px"
                        *ngIf="duration && this.status != simulationStatus.NOT_STARTED">{{ duration }}
                    </span>
                    <span class="status running" *ngIf="this.status == simulationStatus.RUNNING">{{
                        'Running' | translate
                        }}</span>
                    <span class="status ended" *ngIf="this.status == simulationStatus.ENDED">{{ 'Ended' | translate }}</span>
                    <span class="status not-started" *ngIf="this.status == simulationStatus.NOT_STARTED">{{
                        'NotStarted' | translate
                        }}</span>
                </div>
            </div>
        </div>
        <button mat-button class="btn-save btn-common-style hidden-md" (click)="copyInviteLink()">
            {{ 'Copy' | translate }}
        </button>
    </div>
    <div class="logo simulatenow-logo d-flex align-items-center center-side">
        <span>
            <img class="logo" src="../../../../../assets/images/logo.png" alt="logo" />
        </span>
        <span class="app-name font-bold hhidden-sm"> SimulateNow </span>
    </div>
    <div class="group-action-simulation float-right hidden-sm">
        <button mat-button class="btn-end-simulation font-bold btn-common-style" (click)="openLeaveSimulationForm()"
            *ngIf="createdBy == dataModel?.createdBy" style="margin-right: 8px">
            {{ 'Exit' | translate }}
        </button>
        <button mat-button class="btn-exit font-bold btn-common-style" (click)="openStopSimulationForm(data)"
            *ngIf="this.status == simulationStatus.RUNNING && createdBy == dataModel?.createdBy">
            {{ 'Btn_EndSimulation' | translate }}
        </button>
        <button mat-button class="btn-end-simulation font-bold btn-common-style"
            (click)="openShareSimulationeForm(data)"
            *ngIf="this.status == simulationStatus.ENDED && createdBy == dataModel?.createdBy && !hiddenShare">
            {{ 'Btn_Share' | translate }}
        </button>
        <button mat-button style="margin-left: 5px" class="btn-end-simulation font-bold btn-common-style"
            (click)="downloadHistory()"
            *ngIf="this.status == simulationStatus.ENDED && createdBy == dataModel?.createdBy">
            {{ 'Download PDF' | translate }}
        </button>
        <button mat-button style="margin-left: 5px" class="btn-end-simulation font-bold btn-common-style"
            (click)="openPublicSimulationeForm(data)"
            *ngIf="!isPublish && this.status === simulationStatus.ENDED && createdBy == dataModel?.createdBy">
            {{ 'Btn_Public' | translate }}
        </button>
        <!-- <button mat-button class="btn-save font-bold btn-common-style" (click)="openEditSimulationStartedForm()"
            *ngIf="this.status == simulationStatus.ENDED && action != 'edit' && createdBy == dataModel?.createdBy">
            {{ 'Edit' | translate }}
        </button> -->
        <button mat-button class="btn-save font-bold btn-common-style" (click)="openSaveSimulationStartedForm(data)"
            *ngIf="this.status == simulationStatus.ENDED && action == 'edit' && createdBy == dataModel?.createdBy">
            {{ 'Btn_Save' | translate }}
        </button>

        <button mat-button class="btn-end-simulation btn-common-style" (click)="openLeaveSimulationForm()"
            *ngIf="createdBy != dataModel?.createdBy">
            {{ 'LeaveSimulation' | translate }}
        </button>


    </div>
    <div class="group-action-simulation right-side float-right hidden-xs">
        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="copyInviteLink()">
                <mat-icon>file_copy</mat-icon>
                <span>Copy</span>
            </button>
            <button mat-menu-item (click)="openEditSimulationStartedForm()"
                *ngIf="this.status == simulationStatus.ENDED && action != 'edit' && createdBy == dataModel?.createdBy">
                <mat-icon>edit</mat-icon>
                <span>{{ 'Edit' | translate }}</span>
            </button>
            <button mat-menu-item (click)="openShareSimulationeForm(data)"
                *ngIf="this.status == simulationStatus.ENDED && createdBy == dataModel?.createdBy && !hiddenShare">
                <mat-icon>share</mat-icon>
                <span>{{ 'Btn_Share' | translate }}</span>
            </button>
            <button mat-menu-item (click)="openPublicSimulationeForm(data)"
                *ngIf="!isPublish && this.status === simulationStatus.ENDED && createdBy == dataModel?.createdBy">
                <mat-icon>public</mat-icon>
                <span>{{ 'Btn_Public' | translate }}</span>
            </button>
            <button mat-menu-item (click)="openSaveSimulationStartedForm(data)"
                *ngIf="this.status == simulationStatus.ENDED && action == 'edit' && createdBy ==dataModel?.createdBy">
                <mat-icon>save</mat-icon>
                <span>{{ 'Btn_Save' | translate }}</span>
            </button>
            <button mat-menu-item (click)="openStopSimulationForm(data)"
                *ngIf="status == simulationStatus.RUNNING && createdBy == dataModel?.createdBy">
                <mat-icon>trending_flat</mat-icon>
                <span>{{ 'Btn_EndSimulation' | translate }}</span>
            </button>
            <button mat-menu-item (click)="openLeaveSimulationForm()" *ngIf="createdBy == dataModel?.createdBy">
                <mat-icon>exit_to_app</mat-icon>
                <span>{{ 'Exit' | translate }}</span>
            </button>
            <button mat-menu-item *ngIf="createdBy != dataModel?.createdBy" (click)="openLeaveSimulationForm()">
                <mat-icon>exit_to_app</mat-icon>
                <span>{{ 'LeaveSimulation' | translate }}</span>
            </button>
        </mat-menu>
    </div>
</div>
